import {useTitle} from 'hooks';
import {useParams} from 'react-router-dom';

import ProjectsMine from './components/Projects.Mine';
import ProjectsOrgs from './components/Projects.Org';

interface IPageProjectsProps {}

const PageProjects = ({}: IPageProjectsProps) => {
  useTitle('Projects');

  const params = useParams();
  const workspace = params.workspace;

  if (workspace === 'me') {
    return <ProjectsMine />;
  }

  return <ProjectsOrgs slug={workspace} />;
};

export default PageProjects;
